import { render, staticRenderFns } from "./listaExped.vue?vue&type=template&id=6c20aadb"
import script from "./listaExped.vue?vue&type=script&lang=js"
export * from "./listaExped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports